import {
  RenderInPortal,
  RowSectionGrid,
  Z_INDEXES,
  gridCols,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React, {useCallback, useEffect, useState} from 'react';

const LOCAL_STORAGE_KEY = 'GRID_SYSTEM_OVERLAY';

export const GridSystemOverlay: React.FC = () => {
  const [showOverlay, setShowOverlay] = useState<boolean | undefined>(
    undefined,
  );

  const handleToggle = useCallback(() => {
    setShowOverlay(prev => !prev);
  }, [setShowOverlay]);

  useEffect(() => {
    // we use the plain localStorage here because its devtools and the usual hook
    // would only persist to localstorage if we force it with the illegally forcePersistValue_ILLEGALLY flag
    // which would always create an entry
    const value = window.localStorage.getItem(LOCAL_STORAGE_KEY);
    if (value) {
      // eslint-disable-next-line local-rules/set-state-in-use-effect -- just devtools
      setShowOverlay(value === 'true');
    }
  }, []);

  if (showOverlay === undefined) {
    return null;
  }

  return (
    <RenderInPortal portalId="grid-system-overlay-portal-host">
      <ToggleButton onClick={handleToggle}>Toggle layout guides</ToggleButton>
      {showOverlay && (
        <StyledRowSectionGrid>
          <Col />
          <Col />
          <Col />
          <Col />
          <Col />
          <Col />
          <Col />
          <Col />
          <Col />
          <Col />
          <Col />
          <Col />
        </StyledRowSectionGrid>
      )}
    </RenderInPortal>
  );
};

const ToggleButton = styled.button`
  position: fixed;
  bottom: 16px;
  right: 16px;
  z-index: ${Z_INDEXES.GRID_SYSTEM_OVERLAY + 1};
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  border: none;
  padding: 8px 12px;
  border-radius: 4px;
  cursor: pointer;
`;

const StyledRowSectionGrid = styled(RowSectionGrid)`
  position: fixed;
  inset: 0;
  z-index: ${Z_INDEXES.GRID_SYSTEM_OVERLAY};
  pointer-events: none;
  justify-content: center;
`;

const Col = styled.div`
  ${gridCols(1)}
  background-color: #9747FF;
  opacity: 0.08;
  height: 100vh;
`;
